// Catalyst brand detection and configuration
// To switch from testing to production, replace "localhost" with "checkout.catalysttestprep.com"
const CATALYST_DOMAINS = [ "checkout.catalysttestprep.com", "checkout.dev.catalysttestprep.com"];

const isCatalystDomain = () => {
  const hostname = window.location.hostname;
  return CATALYST_DOMAINS.includes(hostname);
};

export const isCatalyst = (businessUnitId) => {
  return isCatalystDomain() || Number(businessUnitId) === 2;
};

export const isSummerCamp = () => {
  // First check regular query params (for non-hash URLs)
  let params = new URLSearchParams(window.location.search);
  
  // If not found, check hash fragment (for hash-based routing like /#/path?type=summerCamp)
  if (!params.has("type") && window.location.hash) {
    const hashQueryString = window.location.hash.split("?")[1];
    if (hashQueryString) {
      params = new URLSearchParams(hashQueryString);
    }
  }
  
  return params.get("type") === "summerCamp";
};

// --- Catalyst refund config ---
export const catalystRefundPoints = [
  "All parents are eligible for course credit for the unused classes within course validity",
  "Refund can be requested within 14 days from date of enrollment. Please refer to the Fee Details email regarding the complete refund policy for your future reference.",
];

export const catalystRefundPolicyUrl =
  "https://cy-assets.s3.ap-south-1.amazonaws.com/policies/catalyst/refund-policy/poilcy_v2.pdf";

// --- Summer camp refund config ---
export const summerCampRefundPoints = [
  "Class 1 is your trial class. If it's not the right fit, let us know before Class 2 starts and we'll refund the 7 unused classes.",
  "Once Class 2 is attended or scheduled, no refund will be applicable.",
  "Please refer to the Fee Details email regarding the complete refund policy for your future reference.",
];

export const summerCampRefundPolicyUrl =
  "https://cy-asset-files.codeyoung.com/student-portal/cancellations/summer_camp_0526/policy.pdf";

// --- Catalyst general config ---
export const catalystTermsUrl =
  "https://www.catalysttestprep.com/terms-conditions";

export const catalystPrivacyPolicyUrl =
  "https://www.catalysttestprep.com/privacy-policy-page";

export const catalystRenewalInfoText =
  "*SAT/ACT/PSAT and AP courses will have a validity of 6 months and 9 months respectively from the date of purchase";
